import React from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import Seo from 'modules/seo/containers/SeoContainer';
import {BaseLayout} from 'modules/layouts/components/Base';
import ErrorBoundary from 'modules/boundary/components/ErrorBoundary';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import {Page} from 'modules/layouts/components/Page';
import {PageCookie} from 'modules/cookies/containers/PageCookie';

export default function CookieSettings() {
	const {checkboxes, list} = useStaticQuery(graphql`
		query {
			checkboxes: cookieCheckboxesListJson {
				checkboxes {
					id
					name
					value
					isDisabled
					isChecked
				}
				text
				link {
					to
					text
				}
			}
			list: cookieListJson {
				list {
					id
					text
				}
				listSecond {
					id
					text
				}
			}
		}
	`);

	return (
		<BaseLayout>
			<ErrorBoundary>
				<Seo title="Cookie settings" />
			</ErrorBoundary>
			<Page>
				<ErrorBoundary>
					<ScrollToTop />
				</ErrorBoundary>
				<ErrorBoundary>
					<PageCookie checkboxes={checkboxes} list={list} />
				</ErrorBoundary>
			</Page>
		</BaseLayout>
	);
}
